<template lang="pug">
div(class="absolute top-full bg-white ")
    ul(data-testid="linkMenu" class="bg-white rounded-sm shadow text-sm py-2 px-4")
        template(v-for="item in data.items" )
            li(
                v-if="$storyblok.isVisible(item)"
                class="py-1"
                v-bind="bindStoryblokBridgeData(item)"
            )
                UniversalLink(
                    v-if="item.link"
                    :link="item.link.url"
                    class="text-gray-darkest font-normal whitespace-nowrap"
                ) {{ item.text }}
</template>

<script>
import UniversalLink from '@/components/universalLink.vue'
import { bindStoryblokBridgeData } from '../../../helpers'
export default {
    name: 'LinkMenu',
    components: { UniversalLink },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    methods: {
        bindStoryblokBridgeData,
    },
}
</script>
